<template lang="html">
	<div id="page__luws" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<LuwsMenu></LuwsMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="luws" v-on:refresh="getLuws" v-bind:per-page="perPage" 
				v-bind:total="luwsAmount" link table-id="luws" ref="table" v-on:create="addLuw" tableHeight="calc(100% - 48px)"
			>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import LuwsMenu from './LuwsMenu.vue';
	import SortTable from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton, LuwsMenu },
		data() {
			return {
				title: 'Погрузочно-разгрузочные рыботы',
				perPage: 50,
				tableColumns: [
					{ label: 'ID',  field: 'id',   default: true, sortable: true },
					{ label: 'Тип', field: 'type_name', sortable: true },
					{ label: 'Город/Направление', field: 'location', sortable: true },
					{ label: 'Мин. время (ч)', field: 'min_time', sortable: true },
					{ label: 'Цена за 1 час (руб.)', field: 'price', sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-luws-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список цен
			 */
             luws() {
				return this.$store.state.cost.luws.map(luw => {
					luw.routerLink = {name: 'LuwPrice', params: {id: luw.id}, query: this.$route.query};
                    luw.type_name  = parseInt(luw.type) === 1 ? 'Город' : parseInt(luw.type) == 2 ? 'Направление' : 'Не определено'
                    luw.location   = parseInt(luw.type) === 1 && luw.city ? luw.city.name : parseInt(luw.type) == 2 && luw.zone ? luw.zone.name : 'Не определено'
					return luw;
				});
			},
			/**
			 * Количество цен
			 */
             luwsAmount() {
				return this.$store.state.cost.luws_amount
			}
		},
		created() {
			this.$store.commit('setTitle', this.title)
		},
		methods: {
			/**
			 * Добавление города
			 */
			addLuw() {
				this.$router.push({ name: 'LuwPrice', params: {id: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getLuws(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-luws-list');
				return this.$store.dispatch('cost/getLuws', {
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-luws-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.type)    model.push(['type',    '=', filter.type]);
                if (filter.city_id) model.push(['city_id', '=', filter.city_id]);
                if (filter.zone_id) model.push(['zone_id', '=', filter.zone_id]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });

				return result;
			},
			/**
			 * Удаление города
			 */
			removeLuw(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-luws-list');
				this.$store.dispatch('cost/deleteLuw', id)
					.then(() => this.$root.$emit('refresh-table', 'luws'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-luws-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removeLuw(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// Luws.vue?2d4f84ae